export default "__VITE_ASSET__DnXeepRw__"